import { EpimsBaseEntityDto } from './epim-base.dto';
export class LanguageDto extends EpimsBaseEntityDto {

    LanguageId: string;

    LanguageName: string;

   

}